import React from 'react';
import { Container } from 'reactstrap';
import NotFound from './NotFound';
import Main from './Main';
import { Switch, Route, useParams } from 'react-router-dom';
import i18n from '../i18n';
import { useEffect } from 'react';
import { supportsCountry, supportsLanguage } from '../utils';
import { countryToLanguage } from '../utils/countryToLanguage';

function LanguageContainer() {
  const { country } = useParams();
  const language = countryToLanguage(country);

  useEffect(() => {
    if (supportsLanguage(language)) {
      i18n.changeLanguage(language);
    }
  }, [language]);
  return supportsCountry(country) ? (
    <Switch>
      <Route path={`/${country}/:checkoutId`}>
        <Main country={country} />
      </Route>
      <Route path="*">
        <Container>
          <NotFound />
        </Container>
      </Route>
    </Switch>
  ) : (
    <Container>
      <NotFound />
    </Container>
  );
}

export default LanguageContainer;
